import { ThemeProvider } from '@mui/material/styles';
import { ThemeProvider as StyledThemeProvider } from "styled-components";

import { getThemeByKey } from './theme-color';

export function ThemedComponent({ children, themeKey = "nursing" }) {
    const selectedTheme = getThemeByKey(themeKey);
    return <ThemeProvider theme={selectedTheme}>
        <StyledThemeProvider theme={selectedTheme}>
            { children }
        </StyledThemeProvider>
    </ThemeProvider>
}
